<div class="header-nav-links">
    <ng-content></ng-content>
</div>
